'use strict';

var index = require('../define-properties/index.js');
var polyfill = require('./polyfill.js');

var define = index;
var getPolyfill = polyfill;

var shim = function shimAssign() {
	var polyfill = getPolyfill();
	define(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};

module.exports = shim;
